// src/services/mongo.js
import axios from "axios";
import { api } from "./helper";
import router from "../routes/routes";
import store from "../store";

const client = axios.create({
  baseURL: api,
  withCredentials: false,
});

client.interceptors.request.use((config) => {
  config.headers.Authorization = "Bearer " + store.state.user.jwt;
  return config;
});

client.interceptors.response.use(
  (response) => {
    if (response.data.data && typeof response.data.data === "string" && response.data.data.indexOf("Unauthorized") > -1) {
      router.push("/logout");
    }
    return response;
  },
  (error) => {
    return { data: error.message };
  }
);

function MongoGetLogs(id, methodNames = []) {
  return client.post('MongoLog/logs', {
    id: id,
    methodNames: methodNames
  });
}

export {
  MongoGetLogs
};
